import { FormSchemaFields } from "@stormwater-software/lib-form";
import { UIControlType } from "@stormwater-software/lib-form-control-types";
import React from "react";
import { withoutKeys } from "../../../utils";
import validator from "../../../utils/FormValidator";
import { getPositionField } from "./UserStepOne";
import ElectronicSignatureAgreementControl from "./ElectronicSignatureAgreementControl";
import DataPrivacyPolicyControl from "./DataPrivacyPolicyControl";
import { env } from '../../../config';
import PasswordValidation, { isPasswordValid } from "../../Shared/PasswordValidation/PasswordValidation";

const schema = {
  firstName: {
    label: "First Name",
    validation: {
      required: true,
      maxLength: 100,
    },
    autoComplete: "given-name",
    style: {
      flexBasis: "50%",
    },
  },
  lastName: {
    label: "Last Name",
    validation: {
      required: true,
      maxLength: 100,
    },
    autoComplete: "family-name",
    style: {
      flexBasis: "50%",
    },
  },

  phone: {
    label: "Phone",
    mask: env.REACT_APP_REGION === "UK" ? "phoneUK" : "phone",
    validation: {
      required: env.REACT_APP_REGION === "UK" ? false : true,
      format: env.REACT_APP_REGION === "UK" ? "" : "phone",
    },
    style: {
      flexBasis: "70%",
    },
  },

  phoneExt: {
    label: "Extension",
    validation: {},
    style: {
      flexBasis: "30%",
    },
    parse: validator.parseNumber,
  },
  position: getPositionField(true),
  password: {
    label: "Password",
    controlType: UIControlType.password,
    validation: {
      required: true,
      custom: (value) => {
        if (!value) return "Password is required";
        if (!isPasswordValid(value)) {
          return "Password does not meet all requirements";
        }
        return null;
      },
    },
    renderAfter: (fieldProps) => {
      return <PasswordValidation password={fieldProps.value || ""} />;
    },
  },
  confirm_password: {
    controlType: UIControlType.password,
    label: "Confirm New Password",
    className: "bottom-outline",
    validation: {
      required: true,
      custom: (value, allValues) => {
        if (!value) return "Please confirm your password";
        if (value !== allValues.password) {
          return "Passwords do not match";
        }
        return null;
      },
    },
  },
  electronicSignatureAgreement: {
    controlType: UIControlType.custom,
    renderControl: constrolProps => {
      return <ElectronicSignatureAgreementControl />;
    },
  },
  dataPolicySignature: {
    controlType: UIControlType.custom,
    renderControl: constrolProps => {
      return <DataPrivacyPolicyControl />;
    },
  },
};



/**
 * UI for user registration
 */
function RegisterUserForm(props) {
  return (
    <FormSchemaFields
      {...props}
      schema={schema}
      className="user-register-form"
    />
  );
}

RegisterUserForm.propTypes = {
  ...withoutKeys(FormSchemaFields.propTypes, [
    "schema",
    "className",
    "initialFormData",
  ]),
};

export default RegisterUserForm;
